import { normalizeUsPhoneDigits } from '@numeo/types-core'

/**
 * Format a US phone number as `+1 (XXX) XXX-XXXX` while typing.
 *
 * The digit parsing (strip non-digits, drop a leading country-code `1`, cap at 10) is the shared
 * `normalizeUsPhoneDigits`; the `+1 (…)` presentation is this variant's own. The formatted value (including
 * the `+1` prefix) is fed back through this function on every keystroke, which is exactly why the shared
 * rule drops a leading `1` — otherwise the prefix's `1` would accumulate and corrupt the number.
 */
export const formatPhone = (raw: string): string => {
    const d = normalizeUsPhoneDigits(raw)
    if (d.length === 0) return ''
    if (d.length <= 3) return `+1 (${d}`
    if (d.length <= 6) return `+1 (${d.slice(0, 3)}) ${d.slice(3)}`
    return `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
}
